export interface SurveyConfig {
  surveyId: string;
  scriptSrc: string;
  title: string;
  triggerDelayMs: number;
  // Sessions the user must complete before the survey appears for the first time.
  // Prevents overwhelming new users. After the first dismissal the 30-day
  // cooldown takes over and the session counter is no longer checked.
  minSessionsBeforeShow: number;
  // Days to suppress re-display after any interaction (dismiss or complete).
  cooldownDays: number;
}

// To rotate surveys: update surveyId + scriptSrc.
// Changing surveyId automatically resets suppression for all users.
export const SURVEY_CONFIG: SurveyConfig = {
  surveyId: 'satisfaction-2026-q2',
  scriptSrc:
    'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd8IbIwKi65ePLytYmD0JxY0hASxfrG8x_2BtfeGgiEmOEX.js',
  title: 'Share Your Feedback',
  triggerDelayMs: 5000,
  minSessionsBeforeShow: 3,
  cooldownDays: 30
};
